/**
 * @author radejdong
 * @class
 * @name GoodsList
 * @description  物品列表
 */
import { post } from '@tencent/pmd-network';
import { parserWaterGoods } from './goods';
import { Toast } from '@tencent/pmd-widget/lib/toast';
import { GAME_PVP } from '@tencent/pmd-tools/lib/game';
import { ConfigInfo } from '@tencent/pmd-config/lib/project';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { getUrlPara } from '@tencent/pmd-tools/lib/url';

// 查询全部可用物品
export const GOODS_STATUS_NOT_SEND_AND_VALID = 'GoodsStatusNotSendAndValid';

// 每次请求的数据量
const requestPageNumber = 10;

/**
 * 查询物品列表
 * @param goodsstatus 查询的物品状态：0:查所有 2是已发放(成功和失败)，4是未发放且未过期，6是未发放且已过期 7即将过期 8新到 9游戏礼包
 * @param pageidx 分页索引
 * @param filter1 筛选类型，一般传活动id，用来筛选某个活动领取的物品
 * @param appfilter 筛选游戏
 * @param num 一次请求的数量
 */
const getMyGoods = function (goodsstatus, pageidx, filter1 = null, appfilter = null, num = requestPageNumber) {
  return requestMyGoods(goodsstatus, pageidx, filter1, null, appfilter, num);
};

/**
 * 查询物品列表
 * @param goodsstatus 查询的物品状态：0:查所有 2是已发放(成功和失败)，4是未发放且未过期，6是未发放且已过期 7即将过期 8新到 9游戏礼包
 * @param pageidx 分页索引
 * @param filter1 筛选类型，一般传活动id，用来筛选某个活动领取的物品
 * @param filter2 筛选类型2
 * @param appfilter 筛选游戏
 * @param num 一次请求的数量
 * @param reqOptions 请求时其他参数
 * @param goodsTypeFilter 筛选物品类型
 */
const requestMyGoods = function (
  goodsstatus,
  pageidx,
  filter1 = null,
  filter2 = null,
  appfilter = null,
  num = requestPageNumber,
  reqOptions = {},
  url = '',
  goodsTypeFilter = null,
) {
  const reqData = {
    appfilter: `${getUrlPara('gid') || ConfigInfo.instance.getTipGid()}`,
    goodsstatus: goodsstatus === GOODS_STATUS_NOT_SEND_AND_VALID ? goodsstatus : parseInt(goodsstatus, 10),
    num,
    pageidx,
    big_time: 4294967294, // uint32最大值4294967295
    orderby_desc: true,
  };
  if (filter1) {
    reqData.filter1 = filter1;
  }
  if (filter2) {
    reqData.filter2 = filter2;
  }
  if (appfilter) {
    reqData.appfilter = appfilter;
  }
  // 查询的物品状态：0:查所有 2是已发放(成功和失败)，4是未发放且未过期，6是未发放且已过期 7即将过期 8新到 9游戏礼包
  // 特殊处理自定义的7/8/9/10/11类型
  if (goodsstatus === 7) { // 【7】 3天后即将过期, 过期时间近的放前面
    reqData.goodsstatus = 4;
    reqData.order_type = 'overduetime';
    reqData.orderby_desc = false;
    const dayAfterThreeTimeStamp = Math.round(new Date(new Date().setHours(24, 0, 0, 0)) / 1000) + 86400 * 2;
    reqData.small_time = Math.round(new Date().getTime() / 1000); // 当前时间
    reqData.big_time = dayAfterThreeTimeStamp; // 三天后24点
  } else if (goodsstatus === 8) { // 【8】 3天内新到的，领取时间近的放前面
    reqData.goodsstatus = 4;
    reqData.order_type = 'winningtime';
    reqData.small_time = Math.round(new Date(new Date().setHours(0, 0, 0, 0)) / 1000) - 86400 * 2; // 三天前0点
  } else if (goodsstatus === 9) { // 【9】游戏礼包
    reqData.goodsstatus = 4;
    reqData.goods_type_filter = [16, 31];
  } else if (goodsstatus === 10) { // 【10】 3天后即将过期, 过期时间远的放前面，用来记录是否有新的即将过期物品
    reqData.goodsstatus = 4;
    reqData.order_type = 'overduetime';
    reqData.orderby_desc = true;
    const dayAfterThreeTimeStamp = Math.round(new Date(new Date().setHours(24, 0, 0, 0)) / 1000) + 86400 * 2;
    reqData.small_time = Math.round(new Date().getTime() / 1000); // 当前时间
    reqData.big_time = dayAfterThreeTimeStamp; // 三天后24点
  } else if (goodsstatus === 11) { // 【11】用券返
    reqData.goodsstatus = 4;
    reqData.order_type = 'winningtime';
    reqData.filter1 = 'verify_lott_first';
  }
  if (goodsTypeFilter) {
    reqData.goods_type_filter = goodsTypeFilter;
  }
  return new Promise((resolve, reject) => {
    post({
      showMsgToast: false,
      url: url
        || GoodsConfigInfo.instance.queryUserWaterListUrl
        || '/gmp.welfarecgi.gift.gift/QueryUserWaterList',
      reqData: {
        ...reqData,
        ...reqOptions,
      },
    })
      .then((response) => {
        console.log(response);

        const goodList = [];
        let listIsEnd = false;
        let total = 0;

        if (response.waters && response.waters.length > 0) {
          for (const water of response.waters) {
            if (water) {
              goodList.push(parserWaterGoods(water));
            }
          }
        } else {
          listIsEnd = true;
        }

        if (response.pageidx === 'end') {
          listIsEnd = true;
        }

        if (response.total) {
          total = response.total;
        }

        const newPageidx = response.pageidx;

        const extra = response.extra || {};

        resolve([listIsEnd, goodList, newPageidx, total, extra]);
      })
      .catch((error) => {
        console.log(error);
        if (error.r === 19) {
          resolve([true, [], 'end', 0]);
        } else if (error.msg) {
          Toast.showFail(error.msg);
          reject(error);
        }
      });
  });
};

/**
 * 请求物品物品列表-参数优化版本-参数改为对象
 * @param {object} info
 * @returns
 */
const requestMyGoodsV2 = function ({
  goodsstatus,
  pageidx,
  filter1 = null,
  filter2 = null,
  appfilter = null,
  num = requestPageNumber,
  reqOptions = {},
  url = '',
  goodsTypeFilter = null,
}) {
  return requestMyGoods(
    goodsstatus,
    pageidx,
    filter1,
    filter2,
    appfilter,
    num,
    reqOptions,
    url,
    goodsTypeFilter,
  );
};
/**
 * 查询物品总数
 */
const getMyGoodsCount = function (goodsstatus) {
  return new Promise((resolve, reject) => {
    getMyGoods(goodsstatus, '', null, null, 0)
      .then((res) => {
        if (res[3]) {
          resolve(res[3]);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * 查询物品数目
 */
const getGoodsCount = function () {
  return new Promise((resolve, reject) => {
    const reqData = { query_type: 100 };
    if (ConfigInfo.instance.getTipGid() !== GAME_PVP) {
      reqData.gid = `${ConfigInfo.instance.getTipGid()}`;
    }

    post({
      url: '/gmp.welfarecgi.gift.gift/QueryUserGoodsData',
      showMsgToast: false,
      reqData,
    })
      .then((response) => {
        console.log(response);
        if (response && response.num) {
          resolve(response.num);
        } else {
          resolve(0);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};


export default {
  getMyGoods,
  requestMyGoods,
  requestMyGoodsV2,
  getGoodsCount,
  getMyGoodsCount,
};

export {
  getMyGoods,
  requestMyGoods,
  requestMyGoodsV2,
  getGoodsCount,
  getMyGoodsCount,
};
